import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Teleport as _Teleport, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container-wide w-100 flex-shrink-1 flex-grow-1 d-flex flex-column card bg-white p-5",
  style: {"min-height":"0"}
}
const _hoisted_2 = { class: "flex-shrink-0 d-flex flex-row justify-content-end mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus" }, null, -1)
const _hoisted_5 = {
  class: "flex-shrink-1 flex-grow-1",
  style: {"min-height":"0"}
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex-grow-1" }
const _hoisted_8 = { class: "m-0" }
const _hoisted_9 = { class: "font-weight-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_translate = _resolveComponent("translate")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InfiniteList = _resolveComponent("InfiniteList")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.organizations.call?.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.rpcClient.isSystemAdmin && _ctx.type === 'CLIENT')
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "my-1 d-block",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/auftraggeber/anlage')))
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode("  "),
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [
                  _createTextVNode("Auftraggeber anlegen")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.rpcClient.isSystemAdmin && _ctx.type === 'CONTRACTOR')
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            class: "my-1 d-block",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push('/bieter/anlage')))
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createTextVNode("  "),
              _createVNode(_component_translate, null, {
                default: _withCtx(() => [
                  _createTextVNode("Bieter einladen")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_InfiniteList, {
        class: "h-100 w-100",
        "get-all-items": _ctx.sortAndFilterUtil.sort(_ctx.organizations.data || [], [ 'name:asc' ]),
        "id-property": 'id',
        "auto-scroll-at-start": ""
      }, {
        element: _withCtx((props) => [
          _createElementVNode("div", {
            class: "card clickable d-flex flex-row align-items-center p-2 mb-2",
            style: {"margin":"0 2px"},
            onClick: ($event: any) => (_ctx.openOrganization(props.item))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(props.item.name), 1)
              ])
            ]),
            (_ctx.rpcClient.isInternalUser)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  icon: "pi pi-users",
                  class: "mr-2",
                  onClick: _withModifiers(($event: any) => (_ctx.router.push('/benutzer?oid=' + props.item.id)), ["stop"])
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_6)
        ]),
        _: 1
      }, 8, ["get-all-items"])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#breadcrumbs" }, [
      _createVNode(_component_Breadcrumb, {
        home: { icon: 'pi pi-home', to: '/' },
        model: _ctx.breadcrumbs
      }, null, 8, ["model"])
    ]))
  ]))
}